import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { createIdMap } from '../../version_mapping/utility'
import { nodesOfTypeWithContentV2 } from '../../utility/TreeHelpers'
import { NodeContentUpdate, ReplacementData } from './types'

export const currentlyBusyAtom = atom(false)

export const workingTreeAtom = atom<{ tree?: INode; resetTree?: () => void }>(
  {},
)
export const workingIdMapAtom = atom((get) => {
  const { tree } = get(workingTreeAtom)
  if (!tree) return
  return createIdMap(tree)
})

export const replacementsAtom = atom<ReplacementData[]>([])
export const nodeTypesAtom = atom<string[]>([])

export const excludedAtom = atom<string[]>([])

export const contentUpdatesAtom = atom((get) => {
  const { tree } = get(workingTreeAtom)
  const replacements = get(replacementsAtom)
  const types = get(nodeTypesAtom)
  const excluded = get(excludedAtom)

  const returnData = { included: [], excluded: [] }

  if (!tree) return returnData
  const contentSearch = replacements.map(({ existing }) => existing)
  const nodes = nodesOfTypeWithContentV2({
    tree,
    searches: contentSearch,
    types,
  })
  return nodes.reduce<{
    included: NodeContentUpdate[]
    excluded: NodeContentUpdate[]
  }>((acc, node) => {
    if (excluded.includes(node.id)) {
      acc.excluded.push({ node, replacements })
    } else {
      acc.included.push({ node, replacements })
    }
    return acc
  }, returnData)
})

export const destinationTextNodesAtom = atom((get) => {
  const { tree } = get(workingTreeAtom)
  const replacements = get(replacementsAtom)
  const types = get(nodeTypesAtom)
  if (!tree) return []
  const contentSearch = replacements.map(({ replaceWith }) => replaceWith)
  const nodes = nodesOfTypeWithContentV2({
    tree,
    searches: contentSearch,
    types,
  })
  return nodes
})
